/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Grid, ICON_ACCOUNT_OUTLINE, ICON_TROPHY_OUTLINE, Message, Spacing, Stack, Text,
} from '@doveit/bricks';
import { formatEuro } from '@doveit/hammer';
import Markdown from 'react-markdown';
import { GOAL_METRICS, IndividualGoal } from '../../../providers/api/dtos';
import AgentProfileBySalesCard from '../../components/agent-profile-by-sales-card/AgentProfileBySalesCard';
import { currentYear } from '../../../utils/time/time';
import GoalPerformanceSummaryCard from '../../components/goal-performance-summary-card/GoalPerformanceSummaryCard';
import TutorialView from '../../../components/tutorial-view/TutorialView';
import { AGENT_GOAL_VIDEO_TUTORIAL } from '../../../constants';

export interface AgentGoalMetricsViewProps {
  goal: IndividualGoal,
}

/**
 * @todo rename to `IndividualGoalMetricsView`
 */
export const AgentGoalMetricsView: React.FC<AgentGoalMetricsViewProps> = ({
  goal,
}) => (
  <Spacing margin={[150, 0, 0]}>
    <Stack gap={300}>
      <Stack gap={200}>
        <Message
          message="Punti ad essere un agente di questo tipo"
          icon={ICON_ACCOUNT_OUTLINE}
        />

        <Grid gutter={75}>
          <Grid.Unit size={{ MD: 1 / 2 }}>
            <AgentProfileBySalesCard targetAgentType={goal.targetAgentType} />
          </Grid.Unit>

          <Grid.Unit size={{ MD: 1 / 2 }}>
            <TutorialView {...AGENT_GOAL_VIDEO_TUTORIAL} />
          </Grid.Unit>
        </Grid>
      </Stack>

      <Stack gap={150}>
        <Message
          message={`Il tuo obiettivo di guadagno annuale per il ${currentYear()} è di ${formatEuro(goal.target)}`}
          icon={ICON_TROPHY_OUTLINE}
        />

        <Text.BodySmall>
          <Markdown components={{ p: ({ _node, ...props }) => props.children }}>
            {'Per raggiungere il tuo obiettivo di guadagno ti è necessario raggiungere un numero minimo di notizie, valutazioni, mandati e vendite.  \nI dati riportati sono aggiornati giornalmente.'}
          </Markdown>
        </Text.BodySmall>
      </Stack>

      <Grid gutter={75}>
        {GOAL_METRICS.map((metric) => (
          <Grid.Unit size={{ MD: 1 / 2 }} key={metric}>
            <GoalPerformanceSummaryCard
              metric={metric}
              goal={goal}
            />
          </Grid.Unit>
        ))}
      </Grid>
    </Stack>
  </Spacing>
);
